import { useRates } from '@/context/RatesContext'
import { RateCards } from '@/components/RateCards'
import { Services } from '@/components/Services'

export function HomePage() {
  const { fxRates, status, error, lastSuccessAt } = useRates()

  return (
    <>
      <RateCards rates={fxRates} status={status} error={error} lastSuccessAt={lastSuccessAt} />
      <Services />
    </>
  )
}
